import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { Center } from '@/components/Center';
import { Column, Row } from '@/components/Grid';
import { InternalLink } from '@/components/InternalLink';
import { MainContent } from '@/components/MainContent';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';

/**
 * A page describing that the organization is not eligible for fund trading.
 * E.g.: If the organization does not have a fund account.
 */
export const NotEligibleForTradePage: FC = () => {
  const texts = useTexts();
  const organizationCmId = useOrganizationCmId();

  return (
    <StyledMainContent>
      <Row>
        <Column $span={6}>
          <WithGap gap="24">
            <h1>{texts.orders.notEligibleForTrading.title}</h1>

            <p className="font-body">
              {texts.orders.notEligibleForTrading.description.part1}{' '}
              <a href="mailto:sios@storebrand.no">sios@storebrand.no</a>{' '}
              {texts.orders.notEligibleForTrading.description.part2}
            </p>
          </WithGap>

          <ButtonContainer>
            <Button
              as={InternalLink}
              to={`/${organizationCmId}`}
              iconLeft="arrow_left"
              variant="tertiary"
            >
              {texts.orders.notEligibleForTrading.button.backToConnect}
            </Button>
          </ButtonContainer>
        </Column>

        <Column $span={6}>
          <Center horizontal>
            <img
              alt="B2B simplicity illustration"
              src={`${window.config.storeblocksAssetsBaseUrl}/illustrations/b2b-simplicity1.svg`}
              height="300"
            />
          </Center>
        </Column>
      </Row>
    </StyledMainContent>
  );
};

const StyledMainContent = styled(MainContent)`
  margin-top: 80px;
`;

const ButtonContainer = styled.div`
  margin-top: 48px;
`;
